import api from '@/apis/fr/frReportConfigListAPI.js';
import Crud from '@/stores/crudBase';

var crud = new Crud('FrReportConfigList', api);

const state = {
  ...crud.state,
  _config: {
    table: 'fr_report_config_list',
    field: {
      key: 'report_id',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
